<template>
  <div class="row g-3">
    <div class="col-12 col-xl-6">
      <WidgetCard title="Consultas com sucesso (mensal)">
        <ChartBar :data="monthlySuccessful" />
      </WidgetCard>
    </div>
    <div class="col-12 col-xl-6">
      <WidgetCard title="Consultas diárias (últ. 6m)">
        <ChartLine :data="dailySuccessful" />
      </WidgetCard>
    </div>

    <div class="col-12 col-xl-6">
      <WidgetCard title="Psiapp+ vs Gratuito">
        <ChartBar :data="subscribersVsNon" :options="stackedOptions" />
      </WidgetCard>
    </div>
    <div class="col-12 col-xl-6">
      <WidgetCard title="Recorrente vs Avulso">
        <ChartBar :data="recurringVsSingle" :options="stackedOptions" />
      </WidgetCard>
    </div>

    <div class="col-12 col-xl-6">
      <WidgetCard title="Parceria vs Geral">
        <ChartBar :data="partnershipVsNot" :options="stackedOptions" />
      </WidgetCard>
    </div>
    <div class="col-12 col-xl-6">
      <WidgetCard title="Pacientes novos vs antigos">
        <ChartBar :data="newVsOldPatient" :options="stackedOptions" />
      </WidgetCard>
    </div>

    <div class="col-12 col-xl-6">
      <WidgetCard title="Status de cobrança">
        <ChartBar :data="billingStatus" :options="stackedOptions" />
      </WidgetCard>
    </div>
    <div class="col-12 col-xl-6">
      <WidgetCard title="Consultas por tipo">
        <ChartBar :data="byType" :options="stackedOptions" />
      </WidgetCard>
    </div>

    <div class="col-12 col-xl-6">
      <WidgetCard title="Boleto vs Cartão">
        <ChartBar :data="paymentMethod" :options="stackedOptions" />
      </WidgetCard>
    </div>
    <div class="col-12 col-xl-6">
      <WidgetCard title="Média diária (mensal)">
        <ChartLine :data="dailyAverage" />
      </WidgetCard>
    </div>

    <div class="col-12">
      <WidgetCard title="Consultas mensais com pacientes distintos">
        <ChartLine :data="distinctPatientsMonthly" />
      </WidgetCard>
    </div>
  </div>
</template>

<script>
import {
  groupSeries,
  singleSeries,
  baseOptions,
  dateTicks,
} from "@/utils/dashboardCharts";
import WidgetCard from "./WidgetCard.vue";

export default {
  name: "DashAppointments",
  components: { WidgetCard },
  props: { data: { type: Object, required: true } },
  data() {
    return {
      stackedOptions: {
        ...baseOptions,
        scales: {
          xAxes: [{ stacked: true, ticks: dateTicks }],
          yAxes: [{ stacked: true, ticks: { beginAtZero: true } }],
        },
      },
    };
  },
  computed: {
    monthlySuccessful() {
      return singleSeries(this.data.monthly_successful || [], "year_month", "total", "Consultas", 0);
    },
    dailySuccessful() {
      return singleSeries(this.data.daily_successful || [], "day", "total", "Consultas", 2);
    },
    subscribersVsNon() {
      return groupSeries(this.data.subscribers_vs_non || [], "year_month", "subscription_status", "total");
    },
    recurringVsSingle() {
      return groupSeries(this.data.recurring_vs_single || [], "year_month", "recurrency_status", "total");
    },
    partnershipVsNot() {
      return groupSeries(this.data.partnership_vs_not || [], "year_month", "partnership_status", "total");
    },
    newVsOldPatient() {
      return groupSeries(this.data.new_vs_old_patient || [], "year_month", "paciente_novo", "total");
    },
    billingStatus() {
      const label = { succeeded: "Sucesso", failed: "Falhou", canceled: "Cancelado", pending: "Pendente" };
      const rows = (this.data.billing_status || []).map((r) => ({
        ...r,
        status: label[r.status] || r.status || "—",
      }));
      return groupSeries(rows, "year_month", "status", "total");
    },
    byType() {
      const rows = (this.data.by_type || []).map((r) => {
        const parts = [r.type === "scheduled" ? "Agendada" : r.type];
        parts.push(r.online ? "Online" : "Presencial");
        if (r.first_appointment) parts.push("1ª");
        return { ...r, cat: parts.join(" · "), total: r.total };
      });
      return groupSeries(rows, "year_month", "cat", "total");
    },
    paymentMethod() {
      const label = { card: "Cartão", boleto: "Boleto" };
      const rows = (this.data.payment_method || []).map((r) => ({
        ...r,
        payment_method: label[r.payment_method] || "Outro",
      }));
      return groupSeries(rows, "year_month", "payment_method", "total");
    },
    dailyAverage() {
      return singleSeries(this.data.daily_average || [], "year_month", "daily_average", "Média/dia", 4);
    },
    distinctPatientsMonthly() {
      return singleSeries(this.data.distinct_patients_monthly || [], "year_month", "total", "Pacientes distintos", 5);
    },
  },
};
</script>
